// Contact Popup
// -------------
(function ($, window, document) {
    const $body = $('body'),
        $window = $(window),
        $document = $(document);

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = 'expires='+ d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }

    function getCookie(cname) {
        var name = cname + '=';
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    }

    $(function () {
        // Show contact pop-up
        // -------------------
        $window.bind('scroll', function () {
            var scrollHeight = $document.height(),
                scrollPosition = $window.height() + $window.scrollTop();

            if ((scrollHeight - scrollPosition) / scrollHeight <= 0.7) {
                $('.popup--contact').addClass('is-visible');
            } else {
                $('.popup--contact').removeClass('is-visible');
            }
        });


        // Hide contact pop-up
        // -------------------
        $('.popup .close').on('click', function() {
            setCookie('popupHidden', true, 7);
            $body.addClass('popup-hidden');
        });
        if (getCookie('popupHidden')) {
            $body.addClass('popup-hidden');
        }
    });
})(jQuery, window, document);
